module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/bp-7-128.020e83cf38bb7c47.png"+" 128w",
        images: [{path: "https://static.sniffspot.com/packs/img/bp-7-128.020e83cf38bb7c47.png",width: 128,height: 85}],
        src: "https://static.sniffspot.com/packs/img/bp-7-128.020e83cf38bb7c47.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/bp-7-128.020e83cf38bb7c47.png"},
        
        width: 128,
        height: 85
      }